import { render, staticRenderFns } from "./calendar-demo.vue?vue&type=template&id=d5898872&"
import script from "./calendar-demo.vue?vue&type=script&lang=js&"
export * from "./calendar-demo.vue?vue&type=script&lang=js&"
import style0 from "./calendar-demo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports